<template>
  <div>
    <oil-form v-if='loading'
              :title='formTitle.toUpperCase()'
              :keys='keys'
              :items='company'
              :createForm='!id || !company.Id'
              :formCallback='formCallBack'
    >
      <template v-slot:header='{id}' v-if='id || company.Id'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn class='mx-8' type='button' icon
                   @click='$router.push({path:`/contract/?companyId=${company.Id || id}`})'
                   v-bind='attrs'
                   v-on='on'
            >
              <v-icon>
                mdi-content-paste
              </v-icon>
            </v-btn>
          </template>
          <span>ДОБАВИТЬ ДОГОВОР</span>

        </v-tooltip>
      </template>

    </oil-form>


    <div v-if='contracts && contracts.length >0'>
      <h2 class='mt-10 mb-10'>Договора</h2>
      <min-table class='mt-5 mb-5'
                 :items='contracts'
                 :headers='companyContracts'
                 @clickPdf='showContractPdf'
                 @clickUpdate='updateContract'
                 @clickDelete='deleteContract'
      />
    </div>

    <div v-if='empows && empows.length >0'>
      <h2 class='mt-10 mb-10'>Доверенности</h2>

      <min-table class='mt-5 mb-5'
                 :items='empows'
                 :headers='companyEmp'
                 @clickUpdate='updateEmpowerment'
                 :is-show-pdf='false'
                 @clickDelete='deleteEmpowerment'
      />
    </div>

  </div>


</template>

<script>

import { companiesService } from '@/services/CompaniesService'
import { formKeys, formTitle } from './setting/CompanyHelper.js'
import { Company } from '@/model/Company'
import { contractsService } from '@/services/ContractsService'
import { empowermentService } from '~/services/EmpowermentService'

export default {
  props: {
    id: String
  },
  components: {
    OilForm: () => import('@/components/helper/oil.form'),
    MinTable: () => import('@/components/helper/table/MinTable')
  },
  data: () => ({
    formTitle: '',
    keys: formKeys,
    company: {
      AccountNumber: '',
      Address: '',
      CompanyName: '',
      ContactPerson: '',
      ContractNumbers: '',
      Manager: '',
      Phone: '+998',
      TaxNo: '',
      IsActive: '',
      HasPrivelege: '',
      Type: '',
      Comment: '',
      Dealer: '',
      VatNo: '',
      BankAddress: '',
      BankName: '',
      MFO: '',
      OKONH: '',
      OKED: ''
    },
    wayBills: [],
    empows: [],
    contracts: [],
    appendixes: [],
    companyContracts: [
      { text: 'НОМЕР', value: 'Number' },
      { text: 'ДАТА', value: 'SignedDate' },
      { text: 'СТАТУС', value: 'Status' }
    ],
    companyEmp: [
      { text: 'НОМЕР', value: 'Number' },
      { text: 'СТАТУС', value: 'Status' }
    ],
    loading: false
  }),
  async created() {
    this.formTitle = formTitle(!this.id)

    if (this.id) {
      const company = await companiesService.getById(this.id)
      this.company = company.data
      this.company.AccountNumber = company.data?.AccountNumber.replace(/(\d{4}(?=(?:\d\d\d)+(?!\d)))/g, '$1' + ' ')
      const contracts = await contractsService.contractCompanyById({ companyId: this.id })
      this.contracts = contracts.data
      const ttn = await contractsService.getCompanyById(this.id)
      this.wayBills = ttn.data
      const empows = await contractsService.getEmpowById(this.id)
      this.empows = empows.data

      this.contracts?.map(contract => {
        const apps = contract?.Appendixes || []
        for (const app of apps) {
          this.appendixes.push(app)
        }
      })
    }
    this.loading = true
  },

  computed: {
    storeType() {
      return this.id ? companiesService.update : companiesService.create
    },
    message(){
      return this.id ? 'покупател удачно изменен' : 'покупател удачно создан'
    }
  },
  methods: {
    /**
     * @param {Company} data
     * @param input
     */
    async formCallBack(data, input,form,func) {
      input.isEdit = false
      const store = this.storeType
      const response = await store(data)
      const id = response.data?.Id

      if (!id) {
        input.isEdit = true
        return
      }

      this.company.Id = response.data?.Id
      this.company = response.data

      func(this.message)

      if (!this.id) {
        this.formTitle = formTitle(false)
        await this.$router.replace({
          path: `/company/${id}`,
          replace: true
        })
      }

    },
    showContractPdf(id) {
      this.showMePdf('contract/print', id)
    },
    updateContract(id) {
      this.$router.push(`/contract/${id}`)
    },
    async deleteContract(id) {
      const response = await contractsService.delete(id)
      const isDelete = response.data
      if (isDelete) {
        const contract = this.contracts.find(({ Id }) => Id === id)
        const index = this.contracts.indexOf(contract)
        this.contracts.splice(index, 1)
        this.$notify({
          group: 'mgs',
          type: 'success',
          title: `Договор под номером ${contract.Number} удачно удален`
        })
      }

    },
    updateEmpowerment(id) {
      this.$router.push(`/procuration/${id}`)
    },
    async deleteEmpowerment(id) {
      const response = await empowermentService.delete(id)
      const isDelete = response.data
      if (isDelete) {
        const empowerment = this.empows.find(({ Id }) => Id === id)
        const index = this.empows.indexOf(empowerment)
        this.empows.splice(index, 1)
        this.$notify({
          group: 'mgs',
          type: 'success',
          title: `Договор под номером ${empowerment.Number} удачно удален`
        })
      }
    }
  },
  watch: {
    'company.IsActive'(name) {

    },
    // 'company.TaxNo'(value) {
    //   this.company.TaxNo = value.replace(/(\d{3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + ' ')
    // },
    'company.AccountNumber'(val) {
      this.company.AccountNumber = val.replace(/(\d{4}(?=(?:\d\d\d)+(?!\d)))/g, '$1' + ' ')
    }

  }
}
</script>
